<template>
  <v-dialog v-model="searchModal" max-width="1080" persistent scrollable>
    <template v-slot:activator="{ on }">
      <span v-if="templateType === 'badge-filter'" v-on="!disabled && on">
        <mf-button
          outlined
          :badge-content="selectedItems.length"
          label="Selecionar produtos"
          icon="sell"
          iconPosition="left"
          fill-icon
          :disabled="disabled"
          :height="40"
          text-transform="none"
        />
      </span>
      <span v-else-if="buttonActivator" v-on="!disabled && on">
        <mf-button
          :text="buttonIsFlat"
          :size="buttonSmall ? 'sm' : 'md'"
          :class="{ link: link }"
          data-cy="chooseProducts"
          :disabled="disabled"
          :label="buttonText"
        />
      </span>

      <div v-else v-on="!disabled && on">
        <mf-search :value="textFieldValue" :error="error" :error-messages="errorMessages" :hide-details="hideDetails" :dense="dense" :loading="loading" />
      </div>
    </template>

    <v-card class="pa-0 modal-graphql-container">
      <v-card-text class="pa-5">
        <mf-tabs-menu v-model="tab" :tabs="tabItems" />
        <mf-icon icon="close" color="cinza-d20" size="24" class="close-icon" @click="handleClose" />
        <graphql-search-content
          v-show="tab === 0"
          ref="graphqlSearch"
          :key="graphqlSearchContentKey"
          :campaign="campaign"
          :offer-type="offerType"
          :is-length-limited="isLengthLimited"
          :max-selected-items="maxSelectedItems"
          :default-import="false"
          :selected-products="selectedItems"
          :disable-groups="disableGroups"
          :window="changeWindow"
          :only-active="onlyActive"
          @confirm-changes="setSelectedItems"
          @cancel="closeModal"
          @change-import-loader="importLoader = $event"
        />

        <import-dynamic-csv-card
          v-show="tab === 1"
          ref="importCard"
          v-model="importDialog"
          :return-default-file="false"
          title="Importar produtos"
          import-label="Importar lista de produtos"
          :required-all-of="requiredFields"
          :fields="importFields"
          logic-text="ou"
          :custom-fields="true"
          :custom-fields-with-disabled="fieldsWithDisabled"
          :show-actions="false"
          :line-limits="10000"
        />

        <mf-action-buttons
          v-if="tab === 0"
          class="mt-4"
          :primary-button="{
            text: 'Confirmar',
            action: () => $refs.graphqlSearch.checkValuesAndConfirmChanges(),
            isVisible: true,
            isDisabled: disableSave || importLoader,
            tooltip: tooltipPrimaryButton,
            tooltipMessage: tooltipPrimaryButtonMessage,
          }"
          :extra-button="{
            text: 'Cancelar',
            action: handleCancel,
            isVisible: true,
          }"
        />

        <mf-action-buttons
          v-else
          :primary-button="{
            text: 'Importar',
            action: () => $refs.importCard.finish(),
            isVisible: true,
            isDisabled: disableSave,
            tooltip: tooltipPrimaryButton,
            tooltipMessage: tooltipPrimaryButtonMessage,
          }"
          :extra-button="{
            text: 'Cancelar',
            action: clearFields,
            isVisible: true,
          }"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import GraphqlSearchContent from './GraphqlSearchContent.vue'
import ImportDynamicCsvCard from './ImportDynamicCsvCard.vue'

export default {
  components: {
    GraphqlSearchContent: GraphqlSearchContent,
    ImportDynamicCsvCard: ImportDynamicCsvCard,
  },
  props: {
    buttonText: {
      type: String,
      default: '',
    },
    buttonActivator: {
      type: Boolean,
      default: false,
    },
    buttonIsFlat: {
      type: Boolean,
      default: false,
    },
    campaign: {
      type: Object,
      default: () => {},
    },
    offerType: {
      type: String,
      default: '',
    },
    error: {
      type: Boolean,
      default: false,
    },
    hideCsvUpload: {
      type: Boolean,
      default: false,
    },
    isSegmentation: {
      type: Boolean,
      default: false,
    },
    buttonSmall: {
      type: Boolean,
      default: false,
    },
    link: {
      type: Boolean,
      default: false,
    },
    disableGroups: {
      type: Boolean,
      default: false,
    },
    returnGroups: {
      type: Boolean,
      default: false,
    },
    isLengthLimited: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: String,
      default: '',
    },
    maxSelectedItems: {
      type: Number,
      default: 0,
    },
    placeholder: {
      type: String,
      default: '',
    },
    selectedItems: {
      type: Array,
      required: true,
      default: () => [],
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disableSave: {
      type: Boolean,
      default: false,
    },
    tooltipPrimaryButton: {
      type: Boolean,
      default: false,
    },
    tooltipPrimaryButtonMessage: {
      type: String,
      default: '',
    },
    onlyActive: {
      type: Boolean,
      default: false,
    },
    templateType: {
      type: String,
      default: '',
    },
    dense: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  provide: function () {
    return {
      objectSelected: this.importGroups,
      updateRequiredColumns: this.updateRequiredColumns,
    }
  },
  data: () => ({
    searchModal: false,
    importDialog: true,
    importLoader: false,
    requiredFields: ['sku', 'ean'],
    selectedColumns: [],
    graphqlSearchContentKey: 0,

    tab: 0,
    tabItems: [
      {
        name: 'Selecionar produtos',
        itemsLength: 0,
        haveLength: false,
      },
      {
        name: 'Importar produtos',
        itemsLength: 0,
        haveLength: false,
      },
    ],
  }),
  computed: {
    importFields() {
      return [
        { text: 'SKU', value: 'sku' },
        { text: 'EAN', value: 'ean' },
      ]
    },
    changeWindow() {
      return this.searchModal ? 1 : 0
    },
    textFieldValue() {
      if (this.placeholder.length && !this.selectedItems.length) {
        return this.placeholder
      } else if (this.selectedItems.length === 0 && !this.placeholder.length) {
        return 'Escolher produtos'
      } else if (this.selectedItems.length === 1) {
        return `${this.selectedItems.length} selecionado`
      } else {
        return `${this.selectedItems.length} selecionados`
      }
    },
    fieldsWithDisabled() {
      return this.importFields.map((obj) => {
        let disabled = false

        if (this.selectedColumns.includes('sku') || this.selectedColumns.includes('ean')) {
          disabled = true
        } else {
          disabled = Boolean(this.selectedColumns.includes(obj.value))
        }

        return { ...obj, disabled }
      })
    },
  },
  methods: {
    handleClose() {
      if (this.tab === 0) this.handleCancel()
      else this.clearFields()
    },
    handleCancel() {
      this.$refs.graphqlSearch.cancel()
      this.graphqlSearchContentKey++
      this.importLoader = false
    },
    importGroups(fileContent) {
      this.tab = 0
      const filterPosition = fileContent.selectedColumns.findIndex((column) => column === 'sku' || column === 'ean')
      const ids = fileContent.file.map((line) => line[filterPosition]).filter((element) => /^\d+$/.test(element.trim()))
      let eans
      let skus

      if (fileContent.selectedColumns[filterPosition] === 'ean') {
        eans = ids
      } else {
        skus = ids
      }

      this.$refs.graphqlSearch.getSelectedProducts({ eans, skus })
    },
    closeModal() {
      this.searchModal = !this.searchModal
    },
    setSelectedItems({ products, productsAndGroups }) {
      if (this.returnGroups) {
        const processed = productsAndGroups.map((item) => {
          return item.products ? { ...item, isGroup: true } : item
        })

        this.$emit('confirm', processed)
        this.$emit('update:selectedItems', processed)
        this.$emit('input', processed)
      } else {
        this.$emit('confirm', products)
        this.$emit('update:selectedItems', products)
        this.$emit('input', products)
      }

      this.closeModal()
    },
    changeIconColor(isNotActive) {
      return isNotActive ? '' : '#C4C4C4'
    },
    clearFields() {
      this.tab = 0
      this.$refs.importCard.closeDialog()
      this.searchModal = false
    },
    updateRequiredColumns(selectedColumns) {
      const filterColumns = selectedColumns.filter((column) => !!column)
      this.selectedColumns = filterColumns

      if (filterColumns.includes('sku') && filterColumns.length === 1) {
        this.requiredFields = ['sku']
      } else if (filterColumns.includes('ean') && filterColumns.length === 1) {
        this.requiredFields = ['ean']
      } else {
        this.requiredFields = ['sku', 'ean']
      }
    },
  },
}
</script>

<style lang="scss">
.modal-graphql-container {
  position: relative;

  .close-icon {
    cursor: pointer;
    position: absolute;
    right: 16px;
    top: 16px;
  }
}

.modal-card {
  .modal-div {
    height: 350px;
    overflow-y: auto;
  }
  .light-background {
    background-color: $cinza-l90;
  }
  .dark-background {
    background-color: $cinza-l90;
  }
  .searched-list {
    border-top: 1px solid $cinza-l70;
  }
  .caption {
    text-decoration: underline;
  }
}
.link {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0.01em;
  color: $marca-0-l40 !important;
  text-transform: none;
  -webkit-text-decoration-line: none;
  text-decoration-line: none;
}
.card-action-align {
  position: absolute;
  width: calc(100% - 35px);
  bottom: 0;
  right: 0;
  background: $branco;
}
.bg-cinza-l90 {
  background-color: $cinza-l90;
}
</style>
